import { Controller } from "@hotwired/stimulus";

const DAY_MS = 24 * 60 * 60 * 1000;

export default class extends Controller {
  static targets = ["start", "end", "days", "remaining"];
  static values = { allowance: Number, bookedByYear: Object, vacation: Boolean };

  connect() {
    this.update();
  }

  update() {
    const start = this.parseDate(this.startTarget.value);
    const end = this.parseDate(this.endTarget.value);

    if (start === null || end === null || end < start) {
      this.daysTarget.textContent = "—";
      if (this.hasRemainingTarget) this.remainingTarget.textContent = "—";
      return;
    }

    this.daysTarget.textContent = Math.round((end - start) / DAY_MS) + 1;
    if (!this.vacationValue || !this.hasRemainingTarget) return;

    const year = new Date(start).getUTCFullYear();
    const booked = this.bookedByYearValue[year];
    if (booked === undefined) {
      this.remainingTarget.textContent = "—";
      return;
    }
    const yearEnd = Date.UTC(year, 11, 31);
    const daysThisYear = Math.round((Math.min(end, yearEnd) - start) / DAY_MS) + 1;
    this.remainingTarget.textContent = `${this.allowanceValue - booked - daysThisYear} de ${this.allowanceValue} (${year})`;
  }

  // "2026-08-01" → UTC timestamp, null when blank.
  parseDate(value) {
    if (!value) return null;
    const [year, month, day] = value.split("-").map(Number);
    return Date.UTC(year, month - 1, day);
  }
}
